import { FormattersTypes } from '@/services/types/formatter'
import markList from '@/views/reports/pickers/add-marks/mark-list';


export default ({ vtag, component, data, key, ctx }: FormattersTypes) => {
  if(!data[key]) return;
  
  if(!data['DT_RowCampaignExternalStatus']) return vtag('div', {}, data[key]);

  component.tag = 'div';

  let icon = null;

  if(data.DT_RowMark || data.DT_RowMark === 0) {
    const markData = markList.find((e) => +e.mark === +data.DT_RowMark);

    icon = vtag('ui-icon', {
      class: [
        markData.class,
        'mark-in-table'
      ],
      props: {
        color: ctx.$colors[markData.color],
        size: 12,
        icon: markData.icon,
      }
    });
  }

  if (data.DT_RowStatus === 'archived' && data.DT_RowName === data[key]) {
    icon = vtag('ui-icon',
      {
        props: {
          size: 12,
          icon: 'fas fa-trash-alt',
          color: 'var(--color-gray50)',
        },
        class: [
          'mark-in-table'
        ],
      }
    )
  }
  
  const tooltipMessage = () =>{
    if(data['DT_RowIntegrationStatus'] !== 'active'){
      return data['DT_RowIntegrationStatusMessage']
    }
    if(!ctx.$PL['integrationPropellerads']){
      return ctx.t('The integration for this campaign is disabled. Purchase the addon from Subscription to restore it.')
    }
  }
 
  return vtag('div', {class: 'campaign-api-wpr'},
    [
      vtag('div',{},[icon,data[key]]),
      ctx.$PL['integrationPropellerads'] && data['DT_RowIntegrationStatus'] === 'active' ?
      vtag('v-tooltip', {
        class: {
          'campaign-api-icon':true,
          'campaign-api-icon--red':data['DT_RowStatus']!=='active',
        },
        attrs: { top: 'top' }
      },[
        vtag('span', {
          slot:'activator'
        },[
          'API'
        ]),
        data['DT_RowStatus']==='active'?
        ctx.t('This campaign is integrated via API with the corresponding traffic source.'):
        ctx.t('The integration status for this campaign is inactive. Please check the settings.')
      ])
        :
      vtag('ui-tooltip-icon', {
        class: 'mr-4 campaign-api__not-active',
        props: {
          preset: 'error',
          text: tooltipMessage()
        }
      })
      ,
    ]
  );
}

